module.exports = __webpack_public_path__ + "static/media/kn.9446e86f.svg";